interface ChevronLeftProps {
  className?: string;
  width?: number;
  height?: number;
}

export const ChevronLeft = ({
  className,
  width = 16,
  height = 16,
}: ChevronLeftProps = {}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M10 12L6 8L10 4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

